import { render, staticRenderFns } from "./LimitSelector.vue?vue&type=template&id=726377e2&scoped=true&"
import script from "./LimitSelector.vue?vue&type=script&lang=js&"
export * from "./LimitSelector.vue?vue&type=script&lang=js&"
import style0 from "./LimitSelector.vue?vue&type=style&index=0&id=726377e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726377e2",
  null
  
)

export default component.exports